const AUTH_SCOPE = '[Auth]';

export namespace AuthActions {

  export class Unauthorized {
    static readonly type = `${ AUTH_SCOPE } Unauthorized`;
  }
}
